// Configurazione API centralizzata
// In produzione, configurare REACT_APP_API_URL nel file .env
const API_BASE_URL = "/api";

export default API_BASE_URL;

